<template>
    <div :class="'mx-auto p-'+padding+' relative'">
        <v-loader></v-loader>
    </div>
</template>

<script>
    import Loader from './../_Partials/Loader';
    export default {
        props: {
            padding: {
                type: Number,
                default: 16
            }
        },
        components: {
            'v-loader': Loader
        }
    }
</script>
